import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'


const OrgCaseView = lazy(() => import ('./OrgCaseView.jsx'))
const SingleCaseView = lazy(() => import('./SingleCaseView.jsx'))

const OrgHeadCaseManagementRoutes = [
    {
        path: '/OrgHeadCasesManagement',
        component: OrgCaseView,
        auth: authRoleAccess.org_head_case_management,
    },
    {

        path: '/org-case/:id',
        component: SingleCaseView,
        auth: authRoleAccess.org_head_case_management,
    },

]

export default OrgHeadCaseManagementRoutes
